<template>
  <section class="artconfig" :class="{configmode: configMode}">

    <ArtsharePopup :referenceId="referenceId" ref="shareModal" />

    <div class="letters" ref="letters" @wheel="horizontalScroll($event, $refs.letters)">
      <span class="arrow">&lt;&lt;&lt;</span>
      <span v-for="letter in alphabet" :key="letter" :class="{selected: selectedLetter == letter, numbers: letter == '123'}">        
        <a v-if="letter == '123'" @click="selectLetter(letter)">
          <span>1</span>
          <span>2</span>
          <span>3</span>
        </a>
        <a v-else @click="selectLetter(letter)">{{ letter }}</a>
      </span>
      <span class="arrow">&gt;&gt;&gt;</span>
    </div>

    <div class="line"></div>
    
    <div class="variants-controls" :class="{showcontrols: showVariantsControls}">
      <a @click="variantsScroll('left')">&lt;</a>
      <a @click="variantsScroll('right')">&gt;</a>
    </div>

    <div class="variants" @scroll="hideVariantControlsIfNeeded" :class="{showcontrols: showVariantsControls}" ref="variants" @wheel="horizontalScroll($event, $refs.variants)">
      <div class="card placeholder"></div>      
      <transition-group class="transitiongroup" name="list" ref="variantsinner" tag="div" v-on:after-enter="scrollCardIfNeeded">
      <div  
        v-for="variant in variants"
        :key="variant.properties.code"
        class="card"
        :code="variant.properties.code"        
        :group="variant.properties.groupCode"        
        :class="{
          selected: selectedVariant ? variant.properties.code == selectedVariant.properties.code : false, 
          shrink: variant.properties.code != variant.properties.groupCode && (!selectedVariant || selectedVariant.properties.groupCode != variant.properties.groupCode)}"
      >
        <!-- {{selectedLetter}} -->
        <div class="preloader"></div>
        <div class="letter" :style="{backgroundImage: `url('${thumbnailsBlobRoot + variant.properties.code}.jpg')`}" @click="selectVariant(variant, true)"></div>        
      </div>
      </transition-group>
      <div class="card placeholder"></div>
    </div>

    <div v-if="!configMode" class="map mapboxgl-map" id="map" :class="{hidden: hideMap}">      
    </div>

    <div class="infobar" ref="infobar">      
      <div class="coordinates" v-html="selectedVariantCoordinates"></div>
      <div v-if="!configMode" class="map-toggle" @click="toggleMap">        
        <span class="arrow up" :class="{down: hideMap}">&lt;&lt;</span>
        <span class="tooltip">&nbsp;{{hideMap ? 'show' : 'hide'}} map</span>
      </div>
      <div class="description">{{selectedVariant ? selectedVariant.properties.description : ""}}</div>
    </div>

    <div class="result fullwidth">
      <div class="input">
        <input
          ref="wordinput"
          type="text"
          @input="wordChangeHandler"
          @touchstart="wordinputTouched"
          @focus="wordinputFocused"
          placeholder="type your word here"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          maxlength="80"
        />
      </div>

      <div v-if="tooBigOrSmall && configMode" class="toobigorsmall">
        {{tooBigOrSmall}}
      </div>

      <div class="frame-container" id="frameContainer" ref="frameContainer" :class="[{zoomed: frameZoomed}, frameStyle.frame.id]" @wheel="horizontalScroll($event, $refs.frameContainer)">
        <transition-group tag="div" name="letter" class="frame" :class="[frameStyle.frame.id, frameStyle.color, frameStyle.mat]" id="frame" ref="frame">
          <div v-for="card in frameModel" 
            :key="card.key"       
            class="letter"              
            :class="{selected: selectedCard === card.key}"   
                    
            @click="selectFrameCardManual(card)"
          >
            {{card.variant.properties.letter}}
            <div class="preloader"></div>
            <div class="letter-thumbnail" :style="{backgroundImage: `url('${thumbnailsBlobRoot + card.variant.properties.code}.jpg')`}"></div>          
          </div>
        </transition-group>        
      </div>
      <div class="frame-settings" :class="{hidden: hideFrameSettings, zoomed: frameZoomed}">
        <div class="width" :class="{notFrameable: tooBigOrSmall }"><span>{{physicalSize.width}}cm</span></div>
        <div class="height" :class="{notFrameable: tooBigOrSmall }"><span>{{physicalSize.height}}cm</span></div>
        <table>
          <tr>
              <td>type:</td>
              <td>
                <!-- <span @click="selectFrameStyle(frames.classic)" :class="{selected: frameStyle.frame.id == 'classic'}">classic</span>  -->
                <span @click="selectFrameStyle(frames.modern)" :class="{selected: frameStyle.frame.id == 'modern'}">modern</span> 
                <!-- <span @click="selectFrameStyle(frames.modernwide)" :class="{selected: frameStyle.frame.id == 'modernwide'}">wide</span>  -->
                <!-- <span @click="selectFrameStyle(frames.metal)" :class="{selected: frameStyle.frame.id == 'metal'}">metal</span> -->
              </td>
          </tr>
            <tr>
              <td>color:</td>
              <td class="colors">
                <transition-group name="colortransition" tag="div" style="overflow: hidden;">
                  <div v-for="color in frameStyle.frame.colors" 
                    :key="color" class="color-wrapper" 
                    :class="{selected: frameStyle.color == color}"
                    @click="selectFrameColor(color)">
                    <div class="color" :class="color"></div>
                  </div>
                </transition-group>
              </td>
            </tr>            
            <tr>
              <td>mat:</td>
              <td class="colors">
                <div class="color-wrapper" :class="{selected: frameStyle.mat == mats.WHITE}" @click="selectFrameMat(mats.WHITE)"><div class="color white"></div></div>
                <div class="color-wrapper" :class="{selected: frameStyle.mat == mats.GREY}" @click="selectFrameMat(mats.GREY)"><div class="color grey"></div></div>
                <div class="color-wrapper" :class="{selected: frameStyle.mat == mats.BLACK}" @click="selectFrameMat(mats.BLACK)"><div class="color black"></div></div>
              </td>
            </tr>
          </table>
      </div>
      <div class="frame-toggle">  

        <div class="frame-undo-btn tooltip" @click="undoShuffle" v-for="(counter,i) in undoCounters" :key="'counter'+i" >
          <span class="tooltiptext">Undo shuffle</span>          
            <div v-for="index in 18" :key="index" class="d" :style="{transform: `rotate(${index*18}deg)`, animationDelay: `${5-index*0.277}s`}"></div>
            <div class="a"></div>         
          <div class="t">{{undoTimer}}</div>
        </div>  

        <div class="frame-toggle-btn tooltip">
          <span class="tooltiptext autohide">Customize frame</span>
          <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" :class="{down: !hideFrameSettings}" ref="frameToggleOpen" @click="toggleFrameSettings">		          
            <line x1="4" y1="22" x2="96" y2="22" stroke="#ccc" stroke-width="10" />
            <circle cx="4" cy="22" r="5" fill="#ccc" />
            <circle cx="96" cy="22" r="5" fill="#ccc" />	
            <circle class="circle1" cx="37" cy="22" r="10" stroke="#ccc" stroke-width="8" fill="white" />
            
            <line x1="4" y1="50" x2="96" y2="50" stroke="#ccc" stroke-width="10" />
            <circle cx="4" cy="50" r="5" fill="#ccc" />
            <circle cx="96" cy="50" r="5" fill="#ccc" />	
            <circle class="circle2" cx="66" cy="50" r="10" stroke="#ccc" stroke-width="8" fill="white" />
            
            <line x1="4" y1="78" x2="96" y2="78" stroke="#ccc" stroke-width="10" />
            <circle cx="4" cy="78" r="5" fill="#ccc" />
            <circle cx="96" cy="78" r="5" fill="#ccc" />	
            <circle class="circle3" cx="30" cy="78" r="10" stroke="#ccc" stroke-width="8" fill="white" />          
          </svg>
        </div>

        <div class="frame-shuffle-btn tooltip">
          <span class="tooltiptext autohide">Shuffle letter styles</span>
          <!-- <div ref="frameShuffle" @click="shuffleFrame"></div> -->
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="6 3 12 12" ref="frameShuffle" @click="shuffleFrame" @mouseenter="animateShuffle" @mouseleave="animateShuffle" @ >

            <mask id="myMask">
              <!-- Everything under a white pixel will be visible -->
              <rect x="0" y="0" width="100" height="100" fill="white" />

              <!-- Everything under a black pixel will be invisible -->
              <polygon points="9,9 11,6 13,9 11,12" fill="black"> 
              <!-- <animateTransform attributeName="transform" -->
                                    <!-- attributeType="XML" -->
                                    <!-- type="translate" -->
                                    <!-- from="0,0" -->
                                    <!-- to="0,5" -->
                                    <!-- dur="0.3s"/> -->
              </polygon>
              <!-- <polygon points="8.5,9 11,5.5 13.5,9 11,12.5" fill="black" /> -->
            </mask>
            <mask id="myMask2">
              <!-- Everything under a white pixel will be visible -->
              <rect x="0" y="0" width="100" height="100" fill="white" />

              <!-- Everything under a black pixel will be invisible -->
              <polygon points="9,9 11,6 13,9 11,12" fill="black" transform="translate(0,0)">   
                  <animateTransform attributeName="transform"
                                    attributeType="XML"
                                    type="translate"
                                    from="0,-10"
                                    to="0,0"
                                    id="shuffletransform1"                        
                                    dur="0.1s"/>           
              </polygon>
              <!-- <polygon points="8.5,9 11,5.5 13.5,9 11,12.5" fill="black" /> -->
            </mask>

            <path d="M 6 6 C 9 6 9 6 11 9 C 13 12 13 12 16 12" stroke="#ccc" stroke-width="1.5" fill="none" > 
            <animate
              attributeName="d"
              attributeType="XML"
              from="M 6 6 C 9 6 9 6 11 9 C 13 12 13 12 16 12"
              to="M 6 12 C 9 12 9 12 11 9 C 13 6 13 6 16 6"
              values="
                M 6 6 C 9 6 9 6 11 9 C 13 12 13 12 16 12;              
                M 6 9 C 9 11 9 11 11 11 C 13 11 13 11 16 9;
                M 6 12 C 9 12 9 12 11 9 C 13 6 13 6 16 6
              "
              dur="0.2s"
              id="shuffletransform2"            
              fill="freeze" />
            </path> 
            <!-- <polygon points="9,9 11,6 13,9 11,12" fill="white" /> -->
            <path d="M 6 12 C 9 12 9 12 11 9 C 13 6 13 6 16 6" stroke="#ccc" stroke-width="1.5" fill="none" mask="url(#myMask2)">
            <animate
              attributeName="d"
              attributeType="XML"
              to="M 6 6 C 9 6 9 6 11 9 C 13 12 13 12 16 12"
              from="M 6 12 C 9 12 9 12 11 9 C 13 6 13 6 16 6"
              values="
                M 6 12 C 9 12 9 12 11 9 C 13 6 13 6 16 6;		
                M 6 9 C 9 7 9 7 11 7 C 13 7 13 7 16 9;
                M 6 6 C 9 6 9 6 11 9 C 13 12 13 12 16 12
              "
              dur="0.2s"
              id="shuffletransform3"            
              fill="freeze" /> 
            </path> 
            <!-- <path d="m 16 6.5 l 16 5.5 l 17 6 z" stroke="#ff0000" stroke-width="1.5" fill="none"/> -->
            <polygon points="15.5,4 15.5,8 18,6" fill="#ccc">
            <animate
              attributeName="points"
              attributeType="XML"
              to="15.5,10 15.5,14 18,12"
              from="15.5,4 15.5,8 18,6" 
              dur="0.2s"
              id="shuffletransform4"            
              fill="freeze" />
            </polygon>    
            <polygon points="15.5,10 15.5,14 18,12" fill="#ccc">
            <animate
              attributeName="points"
              attributeType="XML"
              from="15.5,10 15.5,14 18,12"
              to="15.5,4 15.5,8 18,6"
              dur="0.2s"
              id="shuffletransform5"            
              fill="freeze" />
            </polygon>
          </svg>
        </div>
      </div>

      <button class="frame-zoom tooltip" ref="frameZoom" :class="{zoomed: frameZoomed}" @click="frameZoomed = !frameZoomed; adjustFrameZoom()"><span class="tooltiptext autohide">Zoom</span></button>            
    </div>

    <div class="ctas">
      <button class="getmymap" @click="openShareModal">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <rect x="1" y="1" height="45" width="288" rx="5" ry="5" />
        </svg>
        <span>SHARE AND DOWNLOAD</span>
      </button>
      <!-- <button class="addtocart" @click="addToCart" :disabled="true/*tooBigOrSmall*/" :class="{toobigorsmall: true /*tooBigOrSmall*/ }">
        <span>ADD TO CART</span>
      </button> -->
      <button class="addtocart" v-if="kastner" @click="print" :disabled="tooBigOrSmallKastner || printing" :class="{toobigorsmall: tooBigOrSmallKastner || printing, printing: printing }">
        <span>{{printing ? 'PRINTING...' : 'PRINT'}}</span>
      </button>
      <div v-if="kastner/*tooBigOrSmall*/" class="summary" >        
        <!-- <span style="opacity:0.5;" class="toobigorsmall">{{/*tooBigOrSmall*/}}Ordering temporarily not available because of company changes. Until we are back, please get in touch for any inquiries.</span>
        <br /> -->
        <span class="description">{{frameModel.length}} letters</span>
      </div>
      <div v-else class="summary" style="clear: unset;" >        
        <span style="opacity:0.5;" class="toobigorsmall">{{/*tooBigOrSmall*/}}Online ordering currently not available. For inquiries, please get in touch at <a href="mailto:info@cityphography.com">info@cityphography.com</a> or on Instagram.</span>
        <br />
        <span class="description">{{frameModel.length}} letters</span>
      </div>
      <!-- <div v-else class="summary">
        <span class="description">{{frameModel.length}} letters + frame</span>
        <br />
        <span class="price">{{Math.round((basePrice + frameModel.length * pricePer)*100)/100}} €</span>
      </div> -->
    </div>

    <div class="configButtons" v-if="configMode">
      <div>
        <button class="configOk" @click="configOk" :disabled="tooBigOrSmall" :class="{toobigorsmall: tooBigOrSmall }">
          <span>OK</span>
        </button>    
        <div class="configSummary">
          <span class="description">{{frameModel.length}} letters {{(!tooBigOrSmall ? '+ frame' : '')}}</span>
          <br />
          <span v-if="!tooBigOrSmall" class="price">{{Math.round((basePrice + frameModel.length * pricePer)*100)/100}} €</span>
        </div>
        <button class="configCancel" @click="configCancel">
          <span>Cancel</span>
        </button>
      </div>
    </div>

    <Snackbar ref="snackbar" />
  </section>
</template>

<script>
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
var Diff = require("diff");
import ArtsharePopup from '@/components/ArtsharePopup.vue'; 
import Snackbar from '@/components/Snackbar.vue';
import { mapState } from 'vuex';
import geojsonStatic from '@/assets/cityphography-geojson-colored-20211007203446.json';
import OverlayScrollbars from 'overlayscrollbars';
import {getFrameDimensions} from '@/utils.js'

let variantControlsDebounce = undefined
let undoInterval = undefined

const frames = {
	// classic: {
  //   id: "classic",
  //   //shortId: 'c',
  //   width: 33,
  //   padding: 36,
  //   zoomedTopMargin: 85,
  //   colors: [ "black", "white" ]
  // },
  modern: {
    id: "modern",
    //shortId: 'm',
    width: 18,
    padding: 36,
    zoomedTopMargin: 100,
    colors: [ "black"/*, "red", "white", "grey", "yellow", "brown"*/ ],
    physicalDimensions: {
      borderWidth: 2.3,
      letterWidth: 10,
      letterHeight: 15,
      letterSpacing: 1,
      matPadding: 4
    }
  },
  // modernwide: {
  //   id: "modernwide",
  //   //shortId: 'w',
  //   width: 18,
  //   padding: 63,
  //   zoomedTopMargin: 73,
  //   colors: [ "black"/*, "red", "white", "grey", "yellow", "brown"*/ ]
  // },
  // metal: {
  //   id: "metal",
  //   //shortId: 't',
  //   width: 7,
  //   padding: 63,
  //   zoomedTopMargin: 84,
  //   colors: [ "black", "white" ]
  // }
}
const mats = {
	GREY: "mat-grey",
	WHITE: "mat-white",
	BLACK: "mat-black"
}

let initialLoad = true;

export default {
  name: "Artconfig",
  props: ['configMode'],
  components: { ArtsharePopup, Snackbar },
  emits: ['editDone'],
  data: function() {
    return {   
      thumbnailsBlobRoot: process.env.VUE_APP_THUMBNAILS_BLOB_ROOT,   
      oldText: "",
      selectedLetter: "",      
      selectedVariant: undefined,
      selectedCard: "",
      frames: frames,
      mats: mats,
      frameModel: [],
      frameStyle: {
        frame: frames.modern,
        color: frames.modern.colors[0],
        mat: mats.GREY
      },
      frameZoomed: false,
      frameContainerHeight: 270,
      variantsWidth: 0,
      map: undefined,
      autoPan: true,
      lastOpenedPopup: undefined,
      wordChangeTimeout: undefined,
      hideMap: false,
      hideFrameSettings: true,
      undoTimer: 5,
      undoCounters: [],
      undoFrameModel: [],
      alphabet: [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        // "123",
        // "?"
      ],
      //geojson: geojsonStatic, // no need to be reactive for now     
      printing: false,
      kastner: process.env.VUE_APP_PROD ? false : true,   
    };
  },
  watch: {
    theme() {    
      if(this.mapEnabled)  
        this.map.setStyle(this.mapboxStyle)
    }
  },
  computed: {
    mapboxStyle(){
      return this.theme == 'dark'
        ? 'mapbox://styles/csunyafreemail/ckx950tqh1pob15p8q5yl248g'//'mapbox://styles/mapbox/dark-v10'
        : 'mapbox://styles/csunyafreemail/ckcp2krgq026f1jpcvpvugwe3'
    },
    mapEnabled(){
      return !this.configMode //&& location.hostname === "cityphography.com" // !(location.hostname === "localhost" || location.hostname === "127.0.0.1")      
    },
    tooBigOrSmall: function(){
      if(this.frameModel?.length > 12)
        return "Max 12 letters can be framed due to physical limitations."
      else if(this.frameModel?.length < 3)
        return "Min 3 letters must be framed due to physical limitations."
      else 
        return false
    },
    tooBigOrSmallKastner: function(){
      if(this.frameModel?.length > 20)
        return "Max 20 letters can be printed at once."
      else if(this.frameModel?.length < 1)
        return "Min 1 letter must be selected."
      else 
        return false
    },
    groupedGeojson: function(){ 
      return this.groupBy(/*this.geojson*/geojsonStatic.features, this.coordinatesToString); 
    },
    variants: function(){ 
      return /*this.geojson*/geojsonStatic.features.filter(f => f.properties.letter === this.selectedLetter); 
    },
    selectedVariantCoordinates: function () {
      if(!this.selectedVariant)
        return "";

      let lat = this.selectedVariant.geometry.coordinates[1];
      let lng = this.selectedVariant.geometry.coordinates[0];
        
      let dN = Math.floor(lat);
      let mN = (lat - dN) * 60;         
      let sN =  (mN - Math.floor(mN)) * 60;
      let dmsN = `${dN}°${Math.floor(mN)}’${sN.toFixed(1)}″N`;

      let dE = Math.floor(lng);
      let mE = (lng - dE) * 60;         
      let sE =  (mE - Math.floor(mE)) * 60;
      let dmsE = `${dE}°${Math.floor(mE)}’${sE.toFixed(1)}″E`;

      return `${dmsN} &nbsp; ${dmsE}`;
    },
    referenceId: function(){
      //return btoa(this.frameModel.map(card => card.variant.properties.code).join("|").toLowerCase());
      return btoa(`${this.frameModel.map(card => card.variant.properties.code).join("|").toLowerCase()}_${this.frameStyle.frame.id}_${this.frameStyle.color}_${this.frameStyle.mat}`) 
    },
    showVariantsControls: function(){
      let numberOfVisibleCards = this.variants.filter(v => 
        v.properties.code == v.properties.groupCode || (this.selectedVariant && this.selectedVariant.properties.groupCode == v.properties.groupCode));         
      //return (this.variants.length*86 + (this.variants.length-1)*10) > this.variantsWidth;   
      return (numberOfVisibleCards.length*86 + (numberOfVisibleCards.length-1)*10) > this.variantsWidth;
    },
    ...mapState([
      'pricePer',
      'basePrice',
      'theme'
    ]),
    // ...mapGetters([
    //   'cartFrameModel',      
    //   'cartFrameStyle',      
    //   // ...
    // ]),
    physicalSize(){
      return this.frameStyle ? getFrameDimensions(this.frameModel, this.frameStyle.frame) : null
    } 
  },
  methods: {
    async print(){
      try{
        this.printing = true
        let resp = await fetch(`http://localhost:5182/print?referenceId=${this.referenceId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        let printResp = await resp.json()

        this.$refs.snackbar.show('Generated image [' + printResp.fileName + '] ready to print!')      

        const imageUrl = `http://localhost:5182/temp/${printResp.fileName}`;

        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.top = '-1000px';
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        // A lényeg a CSS: kényszerítjük a képet pontosan A4 méretre
        doc.write(`
            <html>
                <head>
                    <style>
                        @page { 
                            size: A4 landscape; 
                            margin: 0; 
                        }
                        body { 
                            margin: 0; 
                            padding: 0; 
                        }
                        img { 
                            width: 297mm; /* Fix A4 szélesség */
                            height: 210mm; /* Fix A4 magasság */
                            display: block;
                        }
                    </style>
                </head>
                <body>
                    <img src="${blobUrl}" onload="window.print();">
                </body>
            </html>
        `);
        doc.close();

        let _this = this

        iframe.contentWindow.onafterprint = () => {
            URL.revokeObjectURL(blobUrl);
            document.body.removeChild(iframe);
            //_this.$refs.mainCTAtext.innerHTML = 'PRINT'
            _this.printing = false
        };

        // // 1. Iframe létrehozása
        // const iframe = document.createElement('iframe');
        
        // // Rejtve maradjon a felhasználó elől
        // iframe.style.position = 'fixed';
        // iframe.style.right = '100%';
        // iframe.style.bottom = '100%';
        // iframe.style.width = '0';
        // iframe.style.height = '0';
        // iframe.style.border = 'none';

        // // 2. Eseménykezelő: Mi történjen, ha betöltődött a kép?
        // iframe.onload = () => {
        //     // Fókuszba helyezzük az iframe tartalmát (Chrome-nál fontos)
        //     iframe.contentWindow.focus();
        //     // Nyomtatás indítása
        //     iframe.contentWindow.print();

        //     // 3. Takarítás: Miután bezárult a nyomtatási ablak, töröljük az iframe-et
        //     // Az onafterprint nem mindenhol megbízható, ezért egy kis timeout is segít
        //     iframe.contentWindow.onafterprint = () => {
        //         document.body.removeChild(iframe);
        //     };
        // };

        // // 4. Forrás beállítása és hozzáadás az oldalhoz
        // iframe.src = imageUrl;
        // document.body.appendChild(iframe);

      }
      finally{
        //this.printing = false
      }
    },
    hideVariantControlsIfNeeded(){      
      clearTimeout(variantControlsDebounce)
      variantControlsDebounce = setTimeout(() => {
        if(!this.$refs.variants.classList.contains('showcontrols'))
          return

        if(this.$refs.variants.scrollLeft + this.$refs.variants.clientWidth ==  this.$refs.variants.scrollWidth)
          //console.log('fully scrolled LEFT, should hide right control')
          document.querySelector('.variants-controls').classList.add('hideRight')
        else
          //console.log('not fully scrolled left, should show right control')
          document.querySelector('.variants-controls').classList.remove('hideRight')

        if(this.$refs.variants.scrollLeft == 0)
          //console.log('fully scrolled RIGHT, should hide left control')   
          document.querySelector('.variants-controls').classList.add('hideLeft') 
        else
          //console.log('not fully scrolled right, should show left control')  
          document.querySelector('.variants-controls').classList.remove('hideLeft') 
      },500)
    },
    scrollWordInputIntoView(){
      if(OverlayScrollbars(document.body))     
        setTimeout(() =>
          OverlayScrollbars(document.body).scroll({ el : this.$refs.wordinput, block : { y : /*"ifneeded"*/"begin", x : "nearest" }, margin : 50 }, 500)
        ,100);
      else
        this.$refs.wordinput.scrollIntoView({ behavior: 'smooth' }); // fallback to native    
    },
    wordinputTouched(){
      //console.log("touch: " + isTouchDevice() + ", focused: " + (this.$refs.wordinput === document.activeElement))
      this.$hasMobileKeyboard = true
      // if(this.$refs.wordinput === document.activeElement) // commented this one out because I often touched the input after editing the text to scroll up, and the whole thing jumped bc of this back
      //   this.scrollWordInputIntoView()
    },
    wordinputFocused(){
      //console.log("FOCUS, focused: " + (this.$refs.wordinput === document.activeElement))
      if(this.$hasMobileKeyboard){
        //console.log('should scroll keyboard')
         this.scrollWordInputIntoView() 
      }        
    },
    /*!
     * Group items from an array together by some criteria or value.
     * (c) 2019 Tom Bremmer (https://tbremer.com/) and Chris Ferdinandi (https://gomakethings.com), MIT License,
     * @param  {Array}           arr      The array to group items from
     * @param  {String|Function} criteria The criteria to group by
     * @return {Object}                   The grouped object
     */
    groupBy: function (arr, criteria) {
      var reduced = arr.reduce(function (obj, item) {

        // Check if the criteria is a function to run on the item or a property of it
        var key = typeof criteria === 'function' ? criteria(item) : item[criteria];
        // If the key doesn't exist yet, create it
        //if (!obj.hasOwnProperty(key)) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
          obj[key] = [];
        }
        // Push the value to the object
        obj[key].push(item);
        // Return the object to the next item in the loop
        return obj;
      }, {});        
      return Object.keys(reduced).map(key => ({ key, values: reduced[key] }))
    },
    toggleMap(){
      this.hideMap = !this.hideMap
      this.appInsights.trackEvent({name: "Artconfig.ToggleMap", properties: {show: !this.hideMap}})
    },
    toggleFrameSettings(){
      this.hideFrameSettings = !this.hideFrameSettings
      if(this.hideFrameSettings)
        setTimeout(this.adjustFrameZoom, 300)
      else
        this.adjustFrameZoom()
      this.appInsights.trackEvent({name: "Artconfig.ToggleFrameSettings", properties: {show: !this.hideFrameSettings}})
    },
    scrollCardIfNeeded(card){
      if(!card){
        //console.log("ejjha nincs még element mert nem ért véget még a rendering itt, de azt majd elkapja a css javascript hook")        
        return
      }
      // akkor is meg kell hívni ha csak simán választ a user, nem csak animáció végén, mert másképp betűváltásnál triggerelődne csak
      let cardRect = card.getBoundingClientRect()
      let parentRect = this.$refs.variants.getBoundingClientRect()
      if(this.selectedVariant && (this.selectedVariant.properties.code == card.getAttribute('code'))){
        
        let siblings = 0
        let cardMargin = 10
        let cardWidth = 86;
        let tmp = card
        while(tmp.nextSibling && tmp.nextSibling.getAttribute('group') == card.getAttribute('group')){
          siblings++
          tmp = tmp.nextSibling
        }
        if((cardRect.x + cardWidth + (cardMargin + cardWidth)*siblings) > (parentRect.x + parentRect.width)){
          setTimeout(() => this.$refs.variants.scrollLeft += ((cardRect.x + cardWidth + (cardMargin + cardWidth)*siblings) - (parentRect.x + parentRect.width)), 200)
          return
        }

        siblings = 0
        tmp = card
        while(tmp.previousSibling && tmp.previousSibling.getAttribute('group') == card.getAttribute('group')){
          siblings++
          tmp = tmp.previousSibling
        }
        if((cardRect.x - (cardMargin + cardWidth)*siblings) < (parentRect.x)){ 
          setTimeout(() => this.$refs.variants.scrollLeft -= (parentRect.x - (cardRect.x - (cardMargin + cardWidth)*siblings)), 200)
        }
      }
    },
    selectFrameStyle(style){
      this.frameStyle.frame = style;
      this.adjustFrameZoom();
      this.appInsights.trackTrace({message: `FrameStyle: ${this.frameStyle.frame.id}_${this.frameStyle.color}_${this.frameStyle.mat}` })
    },
    selectFrameColor(color){
      this.frameStyle.color = color
      this.appInsights.trackTrace({message: `FrameStyle: ${this.frameStyle.frame.id}_${this.frameStyle.color}_${this.frameStyle.mat}` })
    },
    selectFrameMat(mat){
      this.frameStyle.mat = mat
      this.appInsights.trackTrace({message: `FrameStyle: ${this.frameStyle.frame.id}_${this.frameStyle.color}_${this.frameStyle.mat}` })
    },
    configOk: function(){
      this.$store.commit('setCartFrameModel', {codesArray: this.frameModel.map(card => card.variant.properties.code), styleConfig: this.frameStyle});
      this.$emit('editDone');

      this.appInsights.trackEvent({name: "Artconfig.EditOk", properties: {reference: atob(this.referenceId)}});
    },
    configCancel: function(){
      this.$emit('editDone');
      this.appInsights.trackEvent({name: "Artconfig.EditCancel"});
    },
    addToCart: function(){
      document.getElementsByTagName('header')[0].classList.remove('scrolled'); // TODO with VueX to also update header data model, not just directly fuck with the class
      //document.getElementsByClassName('cart-button')[0].classList.remove('hidden');
      //setTimeout(() => document.getElementsByClassName('status-dot')[0].classList.remove('hidden'), 300);

      this.$store.commit('setCartFrameModel', {codesArray: this.frameModel.map(card => card.variant.properties.code), styleConfig: this.frameStyle});
      //this.$refs.snackbar.show('Successfully added! You can check your cart from the menu.');
      //console.log(this.$store.state.cartFrameModel);
      this.appInsights.trackEvent({name: "Artconfig.AddToCart", properties: {reference: atob(this.referenceId)}});
      this.$router.push('/cart')
    },
    coordinatesToString: function(object){
      return `${object.geometry.coordinates[0].toString()},${object.geometry.coordinates[1].toString()}`;
    },
    getRandomVariant(letter){
      // TODO (some old comment on numbers): if user entered a number, then find it based on code (since all numbers will be under same letter), like ß01 could be "0"1, ß02 could be "0"2, etc...
      let availableCodes = geojsonStatic.features.filter(v => v.properties.letter == letter); 
      let code = availableCodes[Math.floor(Math.random() * availableCodes.length)].properties.code;
      let variant = /*this.geojson*/geojsonStatic.features.find(v => v.properties.code == code);
      return variant
    },
    shuffleFrame(){
      if(!this.frameModel.length)
        return
      this.undoFrameModel = this.frameModel.map(m => m.variant.properties.code)
      //console.log("Everyday I'm shufflin")
      this.animateShuffle()
      this.shuffleCore(false)

      clearInterval(undoInterval)
      this.undoCounters.push(true)
      this.undoTimer = 5
      undoInterval = setInterval(() =>{
        console.log("INTERVAL")
        this.undoTimer--
        if(this.undoTimer == 0){
          clearInterval(undoInterval)
          this.undoCounters = []
        }
      },1000)

      this.appInsights.trackTrace({message: `Shuffle ${this.selectedCard ? 'One' : 'All'}`, properties: {all: !this.selectedCard}})
    },
    shuffleCore(undo){
      let startIndex = 0
      let endIndex = this.frameModel.length
      if(this.selectedCard)
      {
        startIndex = this.frameModel.findIndex(m => m.key == this.selectedCard)
        endIndex = startIndex + 1
      }
      for (let index = startIndex; index < endIndex; index++) {
        let rnd = '_' + Math.random().toString(36).substr(2, 9);
        let letter = this.frameModel[index].variant.properties.letter; 
        let variant = undo ? geojsonStatic.features.find(f => f.properties.code == this.undoFrameModel[index]) : this.getRandomVariant(letter)
        if(this.mapEnabled){
          this.frameModel[index].variant.marker._element.querySelector(`[letter=${letter}]`).classList.remove("framed"); 
          this.frameModel[index].variant.marker._element.classList.remove("framed");
          variant.marker._element.querySelector(`[letter=${letter}]`).classList.add("framed");  
          variant.marker._element.classList.add("framed");
        }
        // update frame model        
        this.frameModel[index].variant = variant
        this.frameModel[index].key = rnd        
        if(this.selectedCard){
          this.selectedCard = rnd
          this.selectVariant(variant, true)
        }
      }
    },
    undoShuffle(){
      this.shuffleCore(true)
      this.undoCounters = []
      this.appInsights.trackTrace({message: `Shuffle Undo ${this.selectedCard ? 'One' : 'All'}`, properties: {all: !this.selectedCard}})
    },
    animateShuffle(){
      document.getElementById('shuffletransform1').beginElement()
      document.getElementById('shuffletransform2').beginElement()
      document.getElementById('shuffletransform3').beginElement()
      document.getElementById('shuffletransform4').beginElement()
      document.getElementById('shuffletransform5').beginElement()
    },
    adjustVariantsControls: function(){
      if(this._inactive)
        return
      this.variantsWidth = this.$refs.variants.offsetWidth; 
      this.hideVariantControlsIfNeeded()     
    },
    adjustFrameZoom: function(){
      if(this._inactive)
        return

      let cardWidth = 92 + 2*3; // card & border + margins
      let cardHeight = 137;
      let frameWidth = (this.frameStyle.frame.width + this.frameStyle.frame.padding)*2.0 + this.frameModel.length*cardWidth;
      let frameHeight = (this.frameStyle.frame.width + this.frameStyle.frame.padding)*2.0 + cardHeight;

      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      //const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      let zoomPadding = vw >= 768 ? 40.0*2 : 25.0*2; 
      if(!this.hideFrameSettings)
        zoomPadding += 20
      let ratio = 1
      let top = 0
      let containerWidth = this.$refs.frameContainer.offsetWidth

      // avoid scroll jumping when zooming in frame, scrolling to right, zoom out and then zooming in again (because chrome restores the scrollLeft value, but it is not animated unlike the css transform)
      if(!this.frameZoomed)
        this.$refs.frameContainer.scrollLeft = 0

      if(this.frameZoomed && frameWidth > containerWidth){    
        this.$refs.frame.$el.style.transform = 'unset';
        this.$refs.frameZoom.style.transform = 'unset';
        this.$refs.frameContainer.style.height = ''        
      }
      else if((frameWidth + zoomPadding) > containerWidth){        
        ratio = ((containerWidth - zoomPadding) / frameWidth).toFixed(3)
        let paddingRemainder = Math.max(0, containerWidth - frameWidth)
        let translateX = (containerWidth - frameWidth*ratio) / 2.0 - paddingRemainder/2        
        if(vw < 992){
          let newContainerHeight = Math.round(this.frameContainerHeight*ratio)
          this.$refs.frameContainer.style.height = `${newContainerHeight}px`
        }
        else{
          top = (this.frameContainerHeight - frameHeight*ratio) / 2.0;  // 270 was the fixed height of frame container, now it's dynamic
          this.$refs.frameContainer.style.height = ''
        }
        this.$refs.frame.$el.style.transformOrigin = 'left top';
        this.$refs.frame.$el.style.transform = `translate(${translateX}px, ${top}px) scale(${ratio})`;   
        this.$refs.frameZoom.style.transform = 'unset';
      }
      else{        
        this.$refs.frame.$el.style.transform = 'unset';
        this.$refs.frameZoom.style.transform = 'scale(0)';
        this.frameZoomed = false
        this.$refs.frameContainer.style.height = ''
      }

      // frame physical measurements
      let measureX = document.querySelector('.frame-settings .width')
      let measureY = document.querySelector('.frame-settings .height')
      let frameMinWidth = vw >= 480 ? 402 : 300;
      let inputHeight = this.configMode ? 49 : 72

      measureX.style.width = Math.max(frameMinWidth*ratio, frameWidth*ratio) + 'px'
      measureX.style.left = (window.innerWidth - Math.max(frameMinWidth*ratio, frameWidth*ratio))/2 + 'px'
      measureX.style.top = inputHeight + 45 + frameHeight*(top > 0 ? 1 : ratio) + 35 + 'px' // input + container top margin + height + distance from frame bottom
      
      measureY.style.width = frameHeight*ratio + 'px'
      measureY.style.left = Math.max((containerWidth - Math.max(frameMinWidth*ratio, frameWidth*ratio))/2 - 45, 15) + 'px' //402 is the min width of frame without any letters typed      
      measureY.style.top = inputHeight+2 + 45 + frameHeight*ratio + top + 'px' // input (+wtf 2px diff) + container top margin + height
    },
    openShareModal: function(){
      if(!this.frameModel.length)
        this.$refs.snackbar.show("Your frame is empty, type something above in the text field!", 4000)
      else
        this.$refs.shareModal.open();      
    },
    wordChangeHandler: function(){  
      // TODO add supported special chars to the "replace" regex to allow them by typing
      //let newText = input.value = input.value.normalize('NFKD').replace(/[^\w]/g, '');
      let newText = this.$refs.wordinput.value = this.$refs.wordinput.value.normalize('NFKD').replace(/[^A-Za-z]/g, '').toLowerCase();      

      if(newText.length == 80)
        this.$refs.snackbar.show("You have reached the max length, 80 characters :)", 4000)

      let diff = Diff.diffChars(this.oldText, newText);

      let i = 0;
      diff.forEach((part) => {    
        if(part.removed){
          // remove card(s) at current index
          for (let index = 0; index < part.value.length; index++) {        
            let removed = this.frameModel.splice(i, 1)[0];           
            if(this.mapEnabled && !this.frameModel.find(f => f.variant.marker == removed.variant.marker && f.variant.properties.letter == removed.variant.properties.letter)){  // in case letter appears more than once in the word, we need to keep the highlight on map even if this one is removed
              removed.variant.marker._element.querySelector(`[letter=${removed.variant.properties.letter}]`).classList.remove("framed"); 
              if(removed.variant.marker._element.querySelectorAll('.framed').length == 0) // dafuq is this condition here????? probably same as two lines above, if we need to keep the highlight, then we must leave the .framed class on the parent as well
                removed.variant.marker._element.classList.remove("framed");
            }
            this.adjustFrameZoom();
          }       
        }
        else if(part.added){
          for (let index = 0; index < part.value.length; index++) {  
            let rnd = '_' + Math.random().toString(36).substr(2, 9);
            let letter = part.value[index]; // TODO if user types any supported special char like # or * or something (nincs még eldöntve mit fogad el begépelni), then map it to the fixed special "letter" responsible for acting as wildcard            
            let variant = this.getRandomVariant(letter)
            if(this.mapEnabled){
              variant.marker._element.querySelector(`[letter=${letter}]`).classList.add("framed");  
              variant.marker._element.classList.add("framed");
              //variant.marker._element.style.zIndex = `${markerZindex++}`;
            }

            // add new card at current index        
            if (i >= this.frameModel.length){
              this.frameModel.push({
                variant: variant,
                key: rnd
              })
            }
            else{
              this.frameModel.splice(i, 0, {
                variant: variant,
                key: rnd
              });  
            }
            // bump index due newly added element
            i++;
            this.adjustFrameZoom();
          }
        }
        else{          
          // if no diff, just proceeed to next index
          for (let index = 0; index < part.value.length; index++) {  
            i++;
          }    
        }       
      });      
      this.oldText = newText;

      clearTimeout(this.wordChangeTimeout);
      this.wordChangeTimeout = setTimeout(() => {
        this.appInsights.trackTrace({message: `Word change: ${newText} (${this.frameModel.map(card => card.variant.properties.code).join("|").toLowerCase()})`});        
      }, 2000);
      
    },
    selectLetter: function(letter) {
      if ((this.selectedLetter === letter && !initialLoad) || this.$refs.letters.classList.contains('dragscroll')) 
        return;
      this.selectedLetter = letter;

      if(this.mapEnabled)
        geojsonStatic.features.forEach(f => {
          f.marker._element.querySelectorAll('span').forEach(s => s.classList.remove('selectedLetter'))

          let spanInMarker = f.marker._element.querySelector(`[letter=${letter}]`);
          if(spanInMarker){
            f.marker._element.classList.add('selectedLetter');
            spanInMarker.classList.add('selectedLetter');
          }
          else
            f.marker._element.classList.remove('selectedLetter');
        });

      //this.appInsights.trackEvent({name: "Artconfig.SelectLetter", properties: {letter: letter}});
    },
    selectVariant: function(variant, flyMap = false){
      if(this.selectedVariant == variant || this.$refs.variants.classList.contains('dragscroll'))
        return;

      this.selectedVariant = variant;

      // if there was a selected card that matches the letter, then set the variant for it in the frame
      let selectedFrameCard = this.frameModel.find(c => c.key == this.selectedCard && c.variant.properties.letter == variant.properties.letter);      
      if(selectedFrameCard){
        let oldVariant = selectedFrameCard.variant;
        selectedFrameCard.variant = variant;

        if(this.mapEnabled){
          // check if need to remove framed class from marker span on map        
          if(!this.frameModel.find(f => f.variant.marker == oldVariant.marker && f.variant.properties.letter == oldVariant.properties.letter)){
            oldVariant.marker._element.querySelector(`[letter=${oldVariant.properties.letter}]`).classList.remove("framed");
            if(oldVariant.marker._element.querySelectorAll('.framed').length == 0)
                oldVariant.marker._element.classList.remove("framed");
          }
          // add framed class for marker span on map based on new variant
          variant.marker._element.querySelector(`[letter=${variant.properties.letter}]`).classList.add("framed");  
          variant.marker._element.classList.add("framed");
          //variant.marker._element.style.zIndex = `${markerZindex++}`;
        }
      }
      
      if(this.mapEnabled && flyMap){
        // we fly to center manually here instead
        var lat = variant.geometry.coordinates[1];
        var lng = variant.geometry.coordinates[0];
        this.autoPan = false;  
        this.lastOpenedPopup && /*variant.popup!= lastOpenedPopup && */this.lastOpenedPopup.remove();
        
        let vidx = variant.popup.variants.findIndex(v => v.properties.code === variant.properties.code);
        let preview = variant.popup._content.querySelector('.letter-preview');
        preview.variantIndex = vidx;
        this.shiftPopupToVariantIndex(preview);

        variant.popup.addTo(this.map);
        this.map.flyTo({center: [lng, lat], offset: [0, 120]});
        this.autoPan = true;
      }

      let el = document.querySelector(`.variants div.card[code='${variant.properties.code}']`)
      this.scrollCardIfNeeded(el)
      this.hideVariantControlsIfNeeded()
      //this.appInsights.trackEvent({name: "Artconfig.SelectVariant", properties: { code: variant.properties.code, flyMap: flyMap }});
    },
    selectFrameCardManual: function(card){  
      if(this.$refs.frameContainer.classList.contains('dragscroll'))
        return;
      // class toggle  
      if(this.selectedCard != card.key){       
        this.selectedCard = card.key;
        this.selectLetter(card.variant.properties.letter); 
        this.selectVariant(card.variant, true);        
        //this.appInsights.trackTrace({message: "Frame card select: " + card.variant.properties.code, properties: {code: card.variant.properties.code}});
      }
      else{
        this.selectedCard = "";
        //this.appInsights.trackTrace({message: "Frame card deselect"});
      }
    },
    variantsScroll: function(direction){
      this.$refs.variants.scrollLeft += (direction == 'left' ? -200 : 200);
    },
    horizontalScroll: function(event, target) {

      let scaleCorrectedScrollWidth = (target.id == 'frameContainer' && !target.classList.contains('zoomed')) ? (this.$refs.frame.$el.getBoundingClientRect().width / target.scrollWidth) : target.scrollWidth

      if(scaleCorrectedScrollWidth <= target.clientWidth || event.deltaX < 0 || event.deltaX > 0)
        return  // no scroll needed or the event is an original horizontal scrolling event

      //if(event.deltaX == 0 || event.deltaX == -0)
        //event.preventDefault()

      const toLeft  = event.deltaY < 0 && target.scrollLeft > 0;      
      const toRight = event.deltaY > 0 && target.scrollLeft < scaleCorrectedScrollWidth - target.clientWidth;
      
      //debugger
      //console.log('wtfscroll toLeft:' + toLeft + ' toRight:' + toRight + ' scrollWidth: ' + target.scrollWidth + ' clientWidth: ' + target.clientWidth + ' delta: ' + event.deltaY + ' scrollLeft: ' + target.scrollLeft + ' offsetWidth: ' + target.offsetWidth + ' id: ' + target.id + ' frameZoom: ' + this.$refs.frame.$el.style.transform + ' bounding: ' + this.$refs.frame.$el.getBoundingClientRect().width)
      if (toLeft || toRight) {
        event.preventDefault();
        target.scrollLeft += event.deltaY*0.5//1
      }
      // eslint-disable-next-line
      else if(target.id == 'frameContainer' && (event.deltaX == 0 || event.deltaX == -0) && target.classList.contains('zoomed'))
        event.preventDefault()
        //debugger
    },
    shiftPopupToVariantIndex: function(preview){    
      if(preview.variants.length == 1)
        return;

      preview.setAttribute('letter', preview.variants[preview.variantIndex].properties.letter);
      preview.setAttribute('code', preview.variants[preview.variantIndex].properties.code);
      preview.style.backgroundImage = `url('${this.thumbnailsBlobRoot}${preview.variants[preview.variantIndex].properties.code}.jpg')`;

      if(preview.variantIndex === 0){
        preview.previousElementSibling.querySelector('.prev').classList.add('empty');
        preview.previousElementSibling.classList.add('empty');
      }
      else{
        preview.previousElementSibling.querySelector('.prev').classList.remove('empty');
        preview.previousElementSibling.classList.remove('empty');
        preview.previousElementSibling.firstElementChild.style.backgroundImage = `url('${this.thumbnailsBlobRoot}${preview.variants[preview.variantIndex-1].properties.code}.jpg')`; 
      }

      if(preview.variantIndex === preview.variants.length - 1){
        preview.nextElementSibling.querySelector('.next').classList.add('empty');
        preview.nextElementSibling.classList.add('empty');
      }
      else{
        preview.nextElementSibling.querySelector('.next').classList.remove('empty');
        preview.nextElementSibling.classList.remove('empty');
        preview.nextElementSibling.firstElementChild.style.backgroundImage = `url('${this.thumbnailsBlobRoot}${preview.variants[preview.variantIndex+1].properties.code}.jpg')`; 
      }
    },
    prevPopupVariant: function(event){  
      let preview = event.target.parentElement.nextElementSibling;  
      if(preview.variantIndex === 0)
        return;
      preview.variantIndex--;      
      this.shiftPopupToVariantIndex(preview); 
      this.selectLetter(preview.variants[preview.variantIndex].properties.letter);
      this.selectVariant(preview.variants[preview.variantIndex]);
      //this.appInsights.trackEvent({name: "Artconfig.PrevPopupVariant", properties: { code: preview.variants[preview.variantIndex].properties.code}});
    },
    nextPopupVariant: function(event){  
      let preview = event.target.parentElement.previousElementSibling;  
      if(preview.variantIndex === preview.variants.length - 1)
        return;
      preview.variantIndex++;
      this.shiftPopupToVariantIndex(preview);       
      this.selectLetter(preview.variants[preview.variantIndex].properties.letter);
      this.selectVariant(preview.variants[preview.variantIndex]);
      //this.appInsights.trackEvent({name: "Artconfig.NextPopupVariant", properties: { code: preview.variants[preview.variantIndex].properties.code}});
    },
    initMap: function(){      
      mapboxgl.accessToken = 'pk.eyJ1IjoiY3N1bnlhZnJlZW1haWwiLCJhIjoiY2tjcDIxNmpoMDRtdTJ6bGdjOXRmMmF2aiJ9.ax_aNeruOVvJkq5RDZUs5g';
      this.map = new mapboxgl.Map({
        container: 'map',
        style: this.mapboxStyle,
        center: [19.052164, 47.490502],
        zoom: 13,
        pitch: 60, 
        bearing: 8
      });
      this.map.addControl(new mapboxgl.NavigationControl({showZoom: false, showCompass: true, visualizePitch: true}));
      //this.map.showPadding = true;
      
      // add markers to map        
      this.groupedGeojson.forEach(grouping => {
        
        let feature = grouping.values[0];                
        let lettersInGroup = [...new Set(grouping.values.map(f => f.properties.letter))]; 

        // create a HTML element for each feature
        var el = document.createElement('div');
        el.className = 'marker hidden';
        el.innerHTML = lettersInGroup.map(l => `<span letter="${l}">${l}</span>`).join('<span class="delimiter">,</span>');

        // create HTML content for popups
        let popupDOM;                
        if(grouping.values.length <= 1){
          popupDOM = document.getElementById("popupsinglevariant").content.firstElementChild.cloneNode(true);
          popupDOM.style.backgroundImage = `url('${this.thumbnailsBlobRoot}${feature.properties.code}.jpg')`; 
          popupDOM.setAttribute('letter', feature.properties.letter);
          popupDOM.setAttribute('code', feature.properties.code);
          popupDOM.variantIndex = 0;
          popupDOM.variants = grouping.values;
        }
        else{
          popupDOM = document.getElementById("popupmultivariant").content.cloneNode(true);
          popupDOM.children[1].variantIndex = 0;
          popupDOM.children[1].variants = grouping.values;
          this.shiftPopupToVariantIndex(popupDOM.children[1]); 
          popupDOM.children[0].addEventListener("click", this.prevPopupVariant);
          popupDOM.children[2].addEventListener("click", this.nextPopupVariant);

          // So below would be in case we have more cards, but the dom is fixed actually, just background shifts
          // popupDOM = document.getElementById("popupmultivariant").content.cloneNode(true);  
          // let temp = document.getElementById("popupsinglevariant");                
          // grouping.values.forEach(feature => {
          //   let variantnode = temp.content.firstElementChild.cloneNode(true);
          //   // TODO set css background to correct image instead of test image
          //   variantnode.style.backgroundImage = "url('images/variant-test.jpg')";
          //   variantnode.setAttribute('letter', feature.properties.letter);
          //   variantnode.setAttribute('code', feature.properties.code);
          // });
        }

        let popup = new mapboxgl.Popup({ offset: 15, maxWidth: 270, closeButton: false, className: 'popup', anchor: 'bottom' })            
          .setDOMContent(popupDOM)
          .on('close', () => { 
            // close event comes sometimes after the open event, which would deselect the already selected one
            if(this.lastOpenedPopup && !this.lastOpenedPopup.isOpen())
              this.selectedVariant = undefined;
          })
          .on('open', e => {
            
            this.lastOpenedPopup = e.target;  
            let preview = e.target._content.querySelector('.letter-preview');
            
            //this.selectLetter(preview.variants[preview.variantIndex].properties.letter);
            this.selectLetter(preview.variants[preview.variantIndex].properties.letter);
            this.selectVariant(preview.variants[preview.variantIndex]);

            if(!this.autoPan)
              return;

            var px = this.map.project(e.target._lngLat); // find the pixel location on the map where the popup anchor is
            var mapx = this.map.project(this.map.getCenter()); // pixel location of the map

            var offsetX = px.x - mapx.x;//map._container.clientWidth/2;
            var offsetY = px.y - mapx.y;//map._container.clientHeight/2;

            if(px.y < e.target._container.clientHeight + 40)
              offsetY = (px.y - e.target._container.clientHeight - 40)*-1 + px.y - this.map._container.clientHeight/2;
            
            if(px.x < e.target._container.clientWidth/2 + 30){
                offsetX =  -mapx.x + 30 + e.target._container.clientWidth/2;
            }
            else if(px.x > mapx.x*2 - e.target._container.clientWidth/2 -30){                        
                offsetX = -e.target._container.clientWidth/2 - 30 + mapx.x; 
            }

            this.map.flyTo({center: e.target._lngLat, offset: [offsetX, offsetY]});
        });
        
        popup.variants = grouping.values;

        // make a marker for each feature and add to the map
        var marker = new mapboxgl.Marker(el)
          .setLngLat(feature.geometry.coordinates)
          .setPopup(popup)
          .addTo(this.map);

        // store references          
        grouping.values.forEach(g => {
          g.popup = popup;
          g.marker = marker;
        });

      });

      setTimeout(() => document.querySelectorAll(".marker.hidden").forEach(m => m.classList.remove('hidden')), 1500);        
    },
    parseFromUrl: function(){   
      let shareHash = this.$router.currentRoute.params['hash'] ?? this.$router.currentRoute.hash?.substring(1)
      //console.log('shareHash: ' + shareHash)
      let hash = (this.configMode && this.$store.state.cartFrameModel) 
        ? `${this.$store.state.cartFrameModel.join("|").toLowerCase()}_${this.$store.state.cartFrameStyle.frame.id}_${this.$store.state.cartFrameStyle.color}_${this.$store.state.cartFrameStyle.mat}`
        : (shareHash ? atob(shareHash) : undefined);
      if(hash){      
        this.appInsights.trackEvent({name: "Artconfig.ParseFromUrl", properties: { hash: hash }});  
        //let codes = hash.toLowerCase().match(/[a-z][0-9]+/g);
        this.frameStyle.frame = frames[hash.split('_')[1]]
        this.frameStyle.color = hash.split('_')[2]
        this.frameStyle.mat = mats[hash.split('_')[3].substring(4).toUpperCase()]
        let codes = hash.toLowerCase().split('_')[0].split('|');
        if(codes.length == 0)
          return;
        this.frameModel = [];
        let word = "";        
        codes.forEach((code, index) => {
          let letter = code[0];
          let variant = /*this.geojson*/geojsonStatic.features.find(f => f.properties.code == code) ?? /*this.geojson*/geojsonStatic.features.find(f => f.properties.letter == letter);
          if(this.mapEnabled){
            variant.marker._element.querySelector(`[letter=${letter}]`).classList.add("framed");  
            variant.marker._element.classList.add("framed");
            //variant.marker._element.style.zIndex = `${markerZindex++}`;
          }
          if(index == 0){
            this.selectedLetter = letter;
            //this.selectVariant(variant, true);
          }
          let rnd = '_' + Math.random().toString(36).substr(2, 9);        
          this.frameModel.push({
            variant: variant,
            key: rnd
          })
          word += letter;
        });        
        this.$refs.wordinput.value = word;
        this.oldText = word;
        this.wordChangeHandler();
        this.adjustFrameZoom();
        if(!this.configMode){
            
          // NOTE: 
          // temporarily disabled scroll as a quick fix so landing experience is improved on mobile, and they see the banner immediately.
          // maybe will be added back eventually
          
          // if(OverlayScrollbars(document.body))     
          //   setTimeout(() =>
          //     OverlayScrollbars(document.body).scroll({ el : /*this.$refs.infobar*/ document.getElementsByClassName('frame-toggle')[0], block : { y : /*"ifneeded"*/"end", x : "nearest" }, margin : 5/*50*/ }, 500)
          //   ,100);
          // else
          //   this.$refs.infobar.scrollIntoView({ behavior: 'smooth' }); // fallback to native      
          // setTimeout(() => this.$refs.snackbar.show("Scroll up and check your word on the map above!", 4000), 2000);              
          setTimeout(() => this.$refs.snackbar.show("Scroll down to check your word on the map. You can type your own in the text field, and customize each letter!", 5000), 2000);              
        }
      }
    },
    enableDragScroll: function(el){    
      el.dragScrollPos = { left: 0, x: 0 }

      el.addEventListener("mousedown", e => {
        el.classList.add("dragscrollstart")      
        // The current scroll
        el.dragScrollPos.left = el.scrollLeft        
        // Get the current mouse position
        el.dragScrollPos.x = e.clientX
      })
      el.addEventListener("mouseleave", () => { el.classList.remove("dragscroll", "dragscrollstart") })
      el.addEventListener("mouseup", () => { setTimeout(() => el.classList.remove("dragscroll", "dragscrollstart"), 100) })
      el.addEventListener("mousemove", e => {        
        if (!el.classList.contains('dragscrollstart')) 
          return
        e.preventDefault()        
        // How far the mouse has been moved
        const dx = e.clientX - el.dragScrollPos.x
        if(dx != 0)
          el.classList.add("dragscroll")  
        // Scroll the element
        el.scrollLeft = el.dragScrollPos.left - dx        
      })
    }
  },
  mounted: function() {       
    this.selectedLetter = "a";       
    if(this.mapEnabled)      
      this.initMap();
    this.parseFromUrl();
    window.addEventListener('resize', this.adjustFrameZoom);
    window.addEventListener('resize', this.adjustVariantsControls);
    this.adjustFrameZoom();
    this.adjustVariantsControls();
    this.selectLetter('a')
    initialLoad = false;
    this.enableDragScroll(this.$refs.variants)
    this.enableDragScroll(this.$refs.letters)
    this.enableDragScroll(this.$refs.frameContainer)    
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustFrameZoom);
    window.removeEventListener('resize', this.adjustVariantsControls);
  },
  activated(){
    this.adjustFrameZoom()
  }  
};
</script>


<style lang="scss">
.artconfig {

  > div {
    max-width: $XL;
    max-width: 1140px;
    margin: 0 auto;

    &.fullwidth{
      max-width: 100%;
      width: 100%;      
    }
  }  

  .letters {
    font-size: 24px;
    line-height: 35px;
    height: 47px;
    margin-top: 40px;
    // overflow-x: scroll;
    // overflow-y: hidden;
    // white-space: nowrap;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow-x: auto;
    user-select: none;

    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    // TODO
    // no Safari support, and many ppl use it both on Mac and iOS
    // so consider JS or no smooth at all
    scroll-behavior: smooth;

    &.dragscroll span a {
      cursor: grabbing;
    }

    @media (max-width: $XL) {
      cursor: grab;
    }

    span {
      //padding-left: 7px;
      //padding-right: 7px;
      margin-left: 5px;
      margin-right: 5px;
      //display: inline-block;
      //float: left;
      flex: 0 0 auto;
      @include animate(/*1*/ 0.2);
      position: relative;

      &:before{
        content: '';
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        // background-color: red;
        transform: translateY(-10px) scaleY(0);
        transition: transform 0.2s ease;
        transform-origin: bottom;
        background-color: var(--color-artconfig-letter-selected-bg);
      }

      a {
        padding-left: 7px;
        padding-right: 7px;
        display: block;
        height: 37px;
        @include animate(1);
        cursor: pointer;
        position: relative;

        &:hover {
          background-color: var(--color-artconfig-letter-hover-bg);
          @include animate(0.1);
          color: var(--color-links);
        }  
      }

      &.numbers {
        margin-right: 0;

        a{
          letter-spacing: -1px;
          //padding-right: 0;

          span{
          margin: 0;
          padding: 0;

            &:first-child{
              font-size: 0.9em;
            }

            &:nth-child(2){
              font-size: 0.8em;
              top: -2px;
              left: -2px;
              position: relative;
            }

            &:last-child{
              font-size: 0.65em;
              position: relative;
              top: -4px;
              left: -2px;
            }
          }
        }
      }  

      &.selected {
        // background-color: var(--color-artconfig-letter-selected-bg); removed to experiment with animated bg
        padding-bottom: 12px;
        @include animate(/*1*/ 0.2);

        &:before{          
          transform: translateY(0) scaleY(1);
          transition: transform 0.2s ease;
          transform-origin: bottom;
          background-color: var(--color-artconfig-letter-selected-bg);
        }

        a {
          //background-color: black;
          color: white;

          &:hover {
            // background-color: var(--color-artconfig-letter-selected-bg);
            background-color: transparent;
          }          
        }
      }

      &.arrow {
        opacity: 0.5;
        letter-spacing: -5px;
        transform: scale(0.5, 1);
        padding: 0 5px 0 5px;
        margin: 2px 10px 0 0;

        @media (min-width: $XL) {
          display: none;
        }

        &:last-child {
          padding: 0 30px 0 0;
        }
      }
    }
  }

  .line {
    border-bottom: 1px solid var(--color-artconfig-letter-selected-bg);
    margin-top: -10px;
    margin-bottom: 9px;
  }

  .variants-controls{
    position: relative;
    display: none;

    @media (min-width: $XL) {
      &.showcontrols{
        display: block;
      }
    }   

    a {
      display: block;      
      top: 65px;
      transform: scaleY(1.5);
      position: absolute;
      font-size: 20px;
      cursor: pointer;
      user-select: none;


      &:first-child{
        left: -25px;
      }

      &:last-child{
        right: -25px;
      }
    }

    &.hideLeft{
      a:first-child{
        cursor: unset;
        opacity: 0.2;
        &:hover{
          color: var(--color-links);
        }
      }
    }
    &.hideRight{
      a:last-child{
        cursor: unset;
        opacity: 0.2;
        &:hover{
          color: var(--color-links);
        }
      }
    }
  }

  .variants {
    margin-top: 20px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;    

    // &.dragscroll .card .letter{
    //   cursor: grabbing;
    // }

    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    // TODO
    // no Safari support, and many ppl use it both on Mac and iOS
    // so consider JS or no smooth at all
    scroll-behavior: smooth;

    .transitiongroup{
      display: flex;
      margin-left: 10px;
    }

    .list-enter-active, .list-leave-active {
      transition: 
        //border 1s ease, 
        width 0.5s ease, 
        margin 0.5s ease;
      //transition: all 1s;
    }
    .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
      width: 0px !important;
      margin: 0 !important;
    }

    .card {
      width: 86px;
      height: 144px;
      flex: 0 0 auto;
      margin-right: 10px;
      pointer-events: none;
      border-bottom: 5px solid var(--color-bg);
      //@include animate(1);
      overflow: hidden;
      //transition: border 1s ease, width 0.5s ease, margin 0.5s ease;
      //background: url(../assets/images/833.svg) center no-repeat;
      // background: url(../assets/images/833.gif) center no-repeat;
      position: relative;

      // preloader text
      // text-align: center;
      // font-family: Averia;
      // font-size: 100px;        
      // width: 86px;
      // text-transform: uppercase;
      // line-height: 134px;
      // color: #f1f1f1;

      .preloader{
        position: absolute;
        width: 86px;
        height: 90px;
        background: url(../assets/images/833.svg) center no-repeat;
        animation: 
            rotate16x 10s ease, 
            fadeOut 2s 8s ease forwards, 
            fadeIn 1s ease;
        top: 21px;
      }

      &:hover {
        border-bottom: 5px solid var(--color-artconfig-variant-bottom-hover);
        @include animate(0.2);
      }

      .letter {
        position: absolute;        
        width: 86px;
        height: 129px;
        //background: url(../assets/images/variant-test.jpg) no-repeat;
        background-repeat: no-repeat;
        background-size: contain;
        cursor: pointer;
        pointer-events: auto;
        top: 0;
        //opacity: 0;
      }

      &.selected {
        border-bottom: 5px solid var(--color-artconfig-variant-bottom);
      }

      &.shrink {
        margin: 0;
        width: 0px;
        transition: border 1s ease, width 0.5s ease, margin 0.5s ease;
      }

      &:last-child{
        margin-right: 5px;
      }
    }

    &.dragscroll .card .letter{
      cursor: grabbing;
    }

    .placeholder {
      width: 0;
      height: 129px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAANElEQVQYV2P8+PHjfwY08O7dOwZGdAmQoJCQEKoETBBkAFwHsiBcAl0QLHH//v3/IDPRAQCJ/SW9Bsyv9AAAAABJRU5ErkJggg==);

      &:first-child {
        margin-left: 0;
        margin-right: 0;
      }      
    }

    &.showcontrols{
      cursor: grab;
      &.dragscroll{
        cursor: grabbing;
      }

      .transitiongroup{
        margin-left: 0;
      }

      .placeholder{
        width: 30px;
        margin-right: 5px;
      }
    } 

    @media (min-width: $XL) {
      .transitiongroup{
        margin-left: 0;
      }

      .card:last-child{
        margin-right: 0;
      }

      &.showcontrols .placeholder{
        width: 0;
        margin-right: 0;
      }      
    }
  }

  .map {
    height: 370px;
    background-color: $lightgray;
    @include animate(0.5);

    &.hidden {
      height: 0;
    }

    * {
      transition: none;
      -webkit-transition: none;
      -moz-transition: none;
      -ms-transition: none;
      -o-transition: none;
    }

    canvas{
      outline: none;
    }

    .mapboxgl-ctrl a.mapboxgl-ctrl-logo{
        opacity: 0.9;
    }

    .mapboxgl-ctrl-attrib{ 
      background-color: transparent;

      a {
        color: #b1b1b1;
        font-size: 10px;
      }
    }

    .mapboxgl-ctrl-group {
      -webkit-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
    }

    .mapboxgl-ctrl-compass .mapboxgl-ctrl-icon {
      opacity: 0.5;
    }

    .marker {
      background-color: white;
      color: black;
      font-size: 20px;
      font-family: "Courier New", Courier, monospace;
      text-align: center;
      padding: 3px 5px;
      cursor: pointer;
      opacity: 1;

      transition: color 0.2s ease, background-color 0.2s ease, opacity 3s;
      // -webkit-transition: color 0.2s ease, background-color 0.2s ease;
      // -moz-transition: color 0.2s ease, background-color 0.2s ease;
      // -ms-transition: color 0.2s ease, background-color 0.2s ease;
      // -o-transition: color 0.2s ease, background-color 0.2s ease;

      &.hidden{
        opacity: 0;
      }

      &.framed{
        z-index: 10;
      }
      &.selectedLetter{
        z-index: 9;
      }

      span.framed{
        color: $orange;
      }
      span.selectedLetter{
        font-weight: bold;
      }
      span.delimiter{
        font-size: 16px;
      }

      &:hover {
        color: $orange;
        background-color: #f5f5f5;
      }
    }

    .popup {
      //   width:150px;
      //   height: 225px;
      z-index: 20;

      .mapboxgl-popup-content {
        padding: 0;
        background: none;
        box-shadow: none;
      }

      .letter-preview {
        width: 150px;
        height: 225px;
        padding: 0;
        border: 3px solid white;
        border-radius: 0;
        //background: url(../assets/images/variant-test.jpg) no-repeat;
        background-repeat: no-repeat;
        background-size: contain;
        box-shadow: 5px 5px 30px 5px rgba(0, 0, 0, 0.2);
        position: relative;
        z-index: 2;
        float: left;
        transition: background-image 0.5s;
      }

      .nav {
        cursor: pointer;
        //width: 150px;
        width: 50px;
        height: 225px;
        //position: absolute;
        // position: relative;
        // z-index: 1;
        // top: 3px;
        margin-top: 3px;
        float: left;
        position: relative;

        span {
          transform: scale(0.5, 1);
          font-size: 80px;
          display: block;
          position: absolute;
          z-index: 3;
          color: white;
          font-weight: bold;
          top: 50%;
          //left: 10px;
          font-family: "Courier New", Courier, monospace;
          user-select: none;
          text-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
        }

        &:hover:not(.empty) {
          span {
            text-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
          }
        }

        &.empty{ 
          cursor: unset;
          
          .fade {
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAANElEQVQYV2P8+PHjfwY08O7dOwZGdAmQoJCQEKoETBBkAFwHsiBcAl0QLHH//v3/IDPRAQCJ/SW9Bsyv9AAAAABJRU5ErkJggg==) !important;

            + span{
              //color: rgb(236, 236, 236);      
              text-shadow: none; 
              opacity: 0.5;     
            }  
          }
        }

        .fade {
          width: 50px;
          height: 225px;
          background: url(../assets/images/variant-test.jpg) no-repeat;
          background-size: cover; // contain;
          position: relative;
          z-index: 1;
          transition: background-image 0.5s;

          &.prev {
            // -webkit-mask-image: radial-gradient(
            //   ellipse farthest-side at right,
            //   black 20%,
            //   transparent
            // );
            mask-image: url(../assets/images/mask-image-left.png);
          }
          &.next {
            background-position: right;
            // -webkit-mask-image: radial-gradient(
            //   ellipse farthest-side at left,
            //   black 20%,
            //   transparent
            // );
            mask-image: url(../assets/images/mask-image-right.png);
          }
        }
      }
    }

    .mapboxgl-popup-tip {
      width: 1px;
      height: 15px;
      border: none;
      background-color: $typogray;

      &::before {
        position: relative;
        bottom: -5px;
        left: -2px;
        content: "";
        display: inline-block;
        width: 5px;
        height: 5px;
        -moz-border-radius: 2.5px;
        -webkit-border-radius: 2.5px;
        border-radius: 2.5px;
        background-color: $typogray;
      }
    }
  }
  
  .infobar {
    padding: 20px;
    height: 40px;    

    .coordinates {
      float: left;
      color: var(--color-artconfig-coordinates-text);
      letter-spacing: -1px;
    }

    .map-toggle {
      float: right;
    }

    .description {
      clear: both;
      padding-top: 10px;
      padding-bottom: 10px;
      float: left;
      color: var(--color-artconfig-coordinates-text);
    }
  }

  .map-toggle
  //,.frame-toggle 
  {
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    color: #c0c0c0;

    span.arrow {
      opacity: 0.5;
      letter-spacing: -5px;
      display: inline-block;
      transform: rotate(90deg) scale(0.5, 1);
      font-size: 20px;
      margin-top: -5px;
      font-weight: bold;

      &.down {
        transform: rotate(-90deg) scale(0.5, 1) translate(-5px, 0px);
      }
    }

    &:hover {
      @include animate(0.1);
      color: $orange;

      .arrow {
        transform: rotate(90deg) scale(0.6, 1.2);
        &.down {
          transform: rotate(-90deg) scale(0.6, 1.2) translate(-5px, 0px);
        }
      }
    }
  }


  .result {
    //min-height: 480px;
    background-color: var(--color-artconfig-bg);
    font-size: 60px;
    text-align: center;
    margin-top: 20px;
    position: relative;
    overflow: hidden;
    
    .input {
      display: flex;      
      padding: 25px 25px 0 25px;
      position: relative;
      z-index: 21;

      @media (min-width: $S) {
        padding: 25px 45px 0 45px;
      }

      input {
        //min-width: 300px;
        width: 100%;
        max-width: 470px;
        margin: 0 auto;
        flex: 1;
        background: none;
        border: none;
        border-bottom: 1px solid #a0a0a0;
        outline: none;
        padding: 10px 0 10px 0;
        line-height: 28px;
        text-align: center;
        font-size: 24px;
        font-family: "Courier New", Courier, monospace;
        color: var(--color-artconfig-input-text);
        text-transform: lowercase;

        &::placeholder {
          font-size: 16px;
          color: var(--color-artconfig-input-placeholder);
        }

        &:focus::placeholder {
          color: transparent;
          //opacity: 0;
        }
      }
    }
   

    .frame-container {
      margin: 45px 0 40px 0;
      height: 270px;
      box-sizing: border-box;

      &.modernwide:not(.zoomed){
        margin: 33px 0 52px 0;
      }

      &.zoomed {
        overflow-x: auto;
        overflow-y: hidden;
        /* margin-bottom: 20px; */
        /* margin: 45px 20px 20px 20px; */
        //padding: 0 10px 0 10px;
        //height: 290px;
        margin-top: -40px;
        padding-top: 85px;
        //margin-bottom: 80px;
        padding-bottom: 70px;
        height: 420px;
        box-sizing: border-box;
        padding-left: 20px;
        padding-right: 20px;
        cursor: grab;

        &.dragscroll{
          cursor: grabbing;
        }

        &.modernwide{
          height: 446px;
        }
      }      

      .frame {
        display: inline-flex;
        padding: 36px;
        height: 137px;
        min-width: 192px; // 2 letters
        border-width: 33px;
        border-style: ridge;
        border-image: url(../assets/images/black-frame.png) 33;
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.4);
        margin: 0 auto;
        //background: url(../assets/images/grey-mat.png) repeat;
        // TODO do some proper texture, not just color
        background-color: #969696;
        position: relative;
        z-index: 20;
        transition: all 0.3s ease, border-image 0s;

        &.modern, &.modernwide{
          border-width: 18px; // fasza ezt lehet igazából szépen animálni ghecc, szóval a vastagsággal nem lesz gond. kép váltás pl classic vs modern nemtom hogy megy          
          border-image: url(../assets/images/modern-frame.png) 14;          
          transition: all 0.3s ease, border-image 0s;

          &.modernwide{ // TODO megnézni hogy ez a selector igy jo-e, hogy .modernwide saját magán szerepel
            padding: 63px;
            //transition: all 0.3s ease, border-image 0s;
          }

          &.brown{
            border-image: url(../assets/images/modern-frame-brown.png) 14; 
          }
        }

        &.metal{
          padding: 63px;
          border-width: 7px; 
          border-image: url(../assets/images/modern-frame.png) 14;
          transition: all 0.3s ease, border-image 0s;

          &.brown{
            border-image: url(../assets/images/modern-frame-brown.png) 14; 
          }
        }

        &.mat-grey{
          background-color: #989898;
          
          .letter{            
            color: #aaaaaa;
            .letter-thumbnail{
              border: 1px solid #d3d3d3;
            }
            
            &.selected{
              box-shadow: 0 0 15px #ffffff;              
              .letter-thumbnail{
                border-color: rgb(245, 245, 245);
              }
              &:hover{                
                box-shadow: 0 0 15px #d0d0d0;
                .letter-thumbnail{
                  border-color: white;
                }
              }
            }
            &:hover{
              box-shadow: 0 0 15px #ffffff;
              .letter-thumbnail{
                border-color: white;
              }              
            }
          }
        }
        &.mat-white{
          background-color: #f0f0f0;

          .letter{            
            color: white;
            .letter-thumbnail{
              border: 1px solid white;
            }
          
            &.selected{
              box-shadow: 0 0 15px #464646;
              .letter-thumbnail{
                border-color: #6b6b6b;
              }
              
              &:hover{
                .letter-thumbnail{
                  border-color: #5a5a5a;
                }                
              }
            }
            &:hover{
              box-shadow: 0 0 15px #808080;
              .letter-thumbnail{
                border-color: #757575;
              }              
              //border-color: black;
            }
          }
        }
        &.mat-black{
          background-color: #202020;          
          
          .letter{            
            color: #303030;
            .letter-thumbnail{
              border: 1px solid #808080;
            }
            
            &.selected{
              box-shadow: 0 0 15px #a0a0a0;
              .letter-thumbnail{
                border-color: #fff;
              }
              
              &:hover{
                box-shadow: 0 0 15px #666666;
                .letter-thumbnail{
                  border-color: white;
                }                
              }
            }
            &:hover{
              box-shadow: 0 0 15px #a0a0a0;              
              .letter-thumbnail{
                border-color: #e4e4e4;
              }              
            }
          }
        }

        @media (min-width: $S) {
          min-width: 294px; // 3 letters
        }

        .letter {
          width: 92px;
          height: 137px;          
          //border: 1px solid white;
          margin: 0 3px;
          //background: url(../assets/images/variant-test.jpg) no-repeat;
          //background: url(../assets/images/833.svg) center no-repeat;
          cursor: pointer;
          @include animate(0.3);
          overflow: hidden;
          
          // preloader text
          position: relative;
          text-align: center;
          font-family: Averia;
          font-size: 40px; 
          text-transform: uppercase;
          line-height: 135px;
          // color: #f1f1f1;
          //animation: fadeIn 1s ease;

          .preloader{
            position: absolute;
            width: 90px;
            height: 90px;
            background: url(../assets/images/833.svg) center no-repeat;
            animation: 
                rotate16x 10s ease, 
                fadeOut 2s 8s ease forwards, 
                fadeIn 2s ease;
            top: 23px;
          }
          
          .letter-thumbnail{
            width: 92px;
            height: 137px;
            box-sizing: border-box;
            border: 1px solid white;
            background-repeat: no-repeat;
            background-size: cover;
            @include animate(0.3);
            position: absolute;
            top: 0;
            //opacity: 0;
            // animation-name: fadeIn; 
            // animation-duration: 1s; 
            // animation-timing-function: ease;
          }

          &:hover {
            box-shadow: 0 0 15px rgb(255, 255, 255);

            .letter-thumbnail{
              border-style: dashed;
            }
          }

          &.selected {
            box-shadow: 0 0 15px white; 
            transform: scale(1.05);

            .letter-thumbnail{
              border-width: 3px;
              border-style: dashed;
            }
          }

          &.letter-enter-active, &.letter-leave-active {
            @include animate(0.3)
          }
          &.letter-enter, &.letter-leave-to /* .list-leave-active below version 2.1.8 */ {
            //background: blueviolet;
            opacity: 0;
            //font-size: 35px;
            width: 0;
            margin: 0;
            //border: none;
            overflow: hidden;
          }
        }        
      }
    }

    .frame-toggle {
      margin: 0 auto;
      width: 160px;
      // position: absolute;
      // left: 50%;
      // bottom: 30px;
      // margin-left: -80px;
      margin-bottom: 30px;
    }

    .frame-settings{
      overflow: hidden;
      //min-height: 200px;
      max-height: 250px;
      cursor: auto;
      font-size: 16px;
      max-width: 800px;
      margin: 0 auto;
      padding-bottom: 15px;
      @include animate(0.8);

      &.hidden {
        min-height: 0;
        max-height: 0;
        padding-bottom: 0;

        .width, .height{
          opacity: 0;
          width: 0 !important;
        }
      }

      &.zoomed{
        .width, .height{
          opacity: 0;
          width: 0 !important;
          //transform: scale(0);
          transition: none;
        }
      }

      .width, .height{
        position: absolute;
        // scaled automatically 
        width: 0;           
        text-align: center; 
        opacity: 1;
        overflow: hidden;
        transition: all 0.3s ease, width 0.9s ease;
        display: flex;

        &:before, &:after{
          content: '';
          flex-grow: 1;
          position: relative;
          border-top: 1px dashed var(--color-artconfig-ruler-border);
          top: 8px;
        }

        &.notFrameable{
          opacity: 0.3;
        }

        span{
          margin: 0;
          padding: 0 8px;
          position: relative;
          font-size: 16px;
          color: var(--color-artconfig-ruler-text);
          &:hover{
            text-decoration: none;
            cursor: auto;
          }
        }
      }

      .height{
        transform-origin: 0 0;
        transform: rotate(-90deg);
      }

      table {
        //width: 70%;  // will only be needed if too many colors wil make it look awkward, and then must fine tune max-width with media queries on the .frameSettings div
        margin: 0 auto;
        td{
          padding: 10px 0 10px 0;
        }
        td:first-child{
          text-align: right;
          padding-right: 40px;
          width: 40%;
          @media (max-width: $S) {
            padding-right: 15px;
          }
        }        
        td:last-child{
          text-align: left;
          padding-left: 4px;
          font-family: Averia;
        }
        td.colors{
          padding-top: 0;
          padding-left: 0;
        }
      }

      span{   
        margin-right: 20px;     
        &:hover{
          text-decoration: underline;
          cursor: pointer;
        }

        &.selected{
          font-weight: bold;
          text-decoration: underline;
        }
      }

      .colortransition-enter-active, .colortransition-leave-active {
        //transition: opacity .5s;
      }
      .colortransition-enter, .colortransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0 !important;
      }

      .color-wrapper{
        width: 42px;
        height: 42px;
        float: left;
        margin-right: 6px;
        border-radius: 5px;
        margin-top: 6px;
        opacity: 0.6;
        border: 1px solid transparent;

        &:hover{
          cursor: pointer; 
          //border: 1px solid #ddd;
          opacity: 1;
          .color{
            box-shadow: 0 0 10px #cccccc;
          }
        }

        &.selected{
          border: 1px solid #a1a1a1;
          opacity: 1;
        }
      }
      .color{
        width: 36px;
        height: 36px;
        border-radius: 3px;  
        margin: 3px;   

        &.grey    { background-color: grey; }
        &.red     { background-color: red; }
        &.yellow  { background-color: yellow; }
        &.white   { background-color: white; width: 34px; height: 34px; border: 1px solid #e1e1e1; }
        &.black   { background-color: black; }
        &.brown   { background-color: brown; }

      }
    }

    .frame-zoom {
      width: 36px;
      height: 36px;
      position: absolute;
      right: 20px;
      bottom: 25px;
      background: url(../assets/images/frame-zoom-in-icon.png) no-repeat;
      //background-position-x: -36px;
      border: none;
      padding: 0;
      cursor: pointer;
      opacity: 0.5;
      background-size: contain;
      outline: none;      

      &:hover {
        opacity: 1;
        width: 40px;
        height: 40px;
        //background-position-x: -40px;
        bottom: 23px;
        right: 18px;
      }

      &.zoomed {
        background: url(../assets/images/frame-zoom-out-icon.png) no-repeat;
        //background-position-x: 0;
        width: 40px;
        height: 40px;
        bottom: 23px;
        right: 18px;
        background-size: contain;

        &:hover {
          opacity: 1;
          width: 36px;
          height: 36px;
          bottom: 25px;
          right: 20px;
        }
      }
    }

    .frame-toggle{
      // height: 30px;
      // line-height: 30px;
      font-size: 14px;
    }
    
    .frame-shuffle-btn {
      width: 25px;
      height: 25px;
      margin-left: 40px; 
      display: inline-block;
      user-select: none;
      outline: none; 

      svg{
        opacity: var(--artconfig-btn-opacity);
        cursor: pointer;
        transition: none;
        > * {
          transition: none;
        }

        &:hover {
          opacity: 1;      
        }
      }
      
      // &:hover div {          
      //   transform: scaleY(-1);
      //   //transform: scale(1.1);        
      // }

      div {        
        opacity: var(--artconfig-btn-opacity);
        cursor: pointer; 
        width: 25px;
        height: 25px;         
        
        background: url(../assets/images/frame-shuffle-icon.png) no-repeat;
        display: inline-block;
        background-size: contain;

        &.flip{
          //transform: scaleY(-1);
          background: url(../assets/images/frame-shuffle-icon.svg) no-repeat;
          background-size: contain;
        }

        &:hover {
          opacity: 1;
          //transform: scaleY(-1);
          //transform: scale(1.1);        
        }

        // &:active{
        //   color: $orange;
        // }
      }
    }

    .frame-undo-btn{
      position: absolute;
      margin-left: -70px;
      margin-top: -3px;
      // margin-top: -1px;
      width: 30px;
      height: 30px;
      display: inline-block;
      //background-color: turquoise;    
      opacity: 0;  
      animation: fadeIn 0.5s ease forwards, fadeOut 1s ease 4.5s forwards;
      user-select: none;
      cursor: pointer;
      //transform: rotate(-15deg);
      //transform: scale(0.95) translateY(1px);
      // TODOOOOO tooltip is skálázódik de egy picivel lehetne kisebb az egész cucc a többi ikonhoz jobban illeszkedjen magasságban

      &:hover{
        .d{
          border-color: #a9a9a9;
        }
        .a{
          border-right-color: #a9a9a9;
        }
        .t{
          color: #a9a9a9;
        }
      }

      .d{
        width: 2px;
        height: 11px;
        // height: 10px;
        border-top: 4px solid #ccc;
        //background-color: black;
        position: absolute;
        transform-origin: bottom;
        left: 14px;
        animation: fadeOutBorder 1s ease forwards;

        &:nth-child(16){
          opacity: 0.7;
        }
        &:nth-child(17){
          opacity: 0.6;
        }
        &:nth-child(18){
          opacity: 0.5;
        }
      }

      .t{
        top: 7px;
        // top: 6px;
        position: relative;
        font-family: Averia;
        color: #ccc;
        //transform: rotate(15deg);
      }

      .a{
        width: 0; 
        height: 0; 
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;         
        border-right:8px solid #ccc;         
        position: absolute;
        left: 9px;
        top: -3px;
        border-radius: 3px;
      }
    }

    .frame-toggle-btn {
      width: 25px;
      height: 25px;
      display: inline-block;
      user-select: none;
      outline: none; 

      svg {        
        opacity: var(--artconfig-btn-opacity);
        cursor: pointer; 

        .circle1,.circle2,.circle3{
          fill: var(--color-artconfig-bg);
        }

        &:hover {
          opacity: 1;      
          .circle1{
            transform: translateX(30px);
          }
          .circle2{
            transform: translateX(-30px);
          }
          .circle3{
            transform: translateX(30px);
          }
        }

        &.down{
          //color: $orange;
          transform: rotate(-90deg);
          opacity: 0.8;
          &:hover {
            opacity: 1;      
          }
          //width: 0;
        }
      }
    }
  }

  .ctas {
    margin-top: 50px;
    overflow: hidden;

    @media (min-width: $L) {
      padding: 0 80px;
    }
    @media (min-width: $XL) {
      padding: 0 30px;
    }

    button {
      position: relative;
      border-radius: 5px;
      text-transform: uppercase;
      width: 290px;
      height: 47px;
      font-size: 18px;
      text-align: center;
      display: block;
      background: none;
      border: none;
      margin: 0 auto;
      outline: none;
      cursor: pointer;
      line-height: 45px;
      padding: 0;
      margin-bottom: 18px;
      user-select: none;

      span {
        position: absolute;
        left: 0;
        top: 0;
        padding-top: 2px;
        width: 250px;
      }

      &.getmymap {
        background: url(../assets/images/send-icon.png) no-repeat;
        background-size: 25px 25px;
        background-position: right 20px center;
        font-family: 'Courier New', Courier, monospace;

        @media (min-width: $L) {
          float: left;
        }

        &:active:not([disabled]){
          transform: scale(0.99);
        }

        svg {
          width: 290px;
          height: 47px;
          position: absolute;
          left: 0;
          top: 0;

          rect {
            stroke: #a1a1a1;
            stroke-width: 2;
            stroke-dasharray: 8 4;
            fill: none;
          }
        }
      }

      &.addtocart {
        color: white;
        background: url(../assets/images/heart-icon.png) no-repeat $orange;
        background-size: 25px 25px;
        background-position: right 20px center;
        font-family: "Times New Roman", Times, serif;

        @media (min-width: $L) {
          float: right;
        }

        &.toobigorsmall{
          opacity: 0.2;
          cursor: unset;          
        }

        &:active:not([disabled]){
          background-color: #e23703;
          transform: scale(0.99);
        }

        &.printing{
          background: url(../assets/images/spinner.svg) no-repeat $orange;  
          background-size: 25px 25px;
          background-position: right 20px center;
          transform: none;
        }
      }
      
      &:hover:not(.toobigorsmall) {
        background-size: 29px 29px;
        background-position: right 18px center;

        // &.addtocart{
        //     //box-shadow: 0px 0px 20px 0px rgba(255,60,0,0.5);
        //     background: linear-gradient(90deg, rgba(215,79,0,1) 0%, rgba(255,60,0,1) 65%, rgba(255,60,0,1) 100%), url(../assets/images/heart-icon.png) no-repeat;
        // }

        rect {
          //stroke: $orange !important;
          //stroke-dasharray: 12 6 !important;
          //stroke-width: 3 !important;

          stroke-dashoffset: 2;
          //stroke-dashoffset: 500;
          //@include animate(30);
        }
      }
      
    }

    .summary {
      width: 290px;
      margin: 0 auto;
      text-align: right;
      //user-select: none;

      @media (min-width: $L) {
        clear: both;
        float: right;
      }

      .toobigorsmall{
        font-family: Averia;
        color: var(--color-error);
        transition: none;
      }

      .description {
        font-size: 12px;
      }
    }
  }

  &.configmode{
    .infobar{
      display: none;
    }
    .ctas{
      //margin-top: 0;
      display: none;
    }
        
    .result{
      //min-height: 460px;
      background-color: var(--color-bg);
      margin-bottom: 80px;
      padding-bottom: 80px;

      .toobigorsmall{
        font-family: Averia;
        color: var(--color-error);
        font-size: 16px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      }

      .input{
        padding-top: 0;
      }

      .frame-zoom{
        bottom: 105px;
        
        &:hover{
          bottom: 103px;
        }
      }

      .frame-settings {
        .width, .height{
          span{
            background-color: var(--color-bg);
          }
        }
      }
    }
    .configButtons{

      position: fixed;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 400;     
      //padding: 20px 25px 0;
      padding: 20px 20px 0;
      box-shadow: var(--shadow-cart-countries);
      background-color: var(--color-header);
      max-width: unset;

      @media (min-width: $S) {
        padding: 20px 25px 0;
      }      

      > div {
        max-width: 1140px;
        margin: 0 auto;
      }

      .configSummary{
        float: right;
        text-align: right;
        padding: 3px 15px 0 0;
        letter-spacing: -1px;
        //user-select: none;

        @media (min-width: $S) {
          letter-spacing: normal;
          padding: 3px 20px 0 0;
        }

        .toobigorsmall{
          font-family: Averia;
          color: #960505;
          transition: none;
        }

        .description {
          font-size: 12px;
        }
      }

      button{
        position: relative;
        border-radius: 5px;
        //text-transform: uppercase;
        width: 70px;
        height: 47px;
        font-size: 16px;
        text-align: center;
        display: block;
        background: none;
        border: none;
        margin: 0 auto;
        outline: none;
        cursor: pointer;
        line-height: 45px;
        padding: 0;
        margin-bottom: 18px;
        user-select: none;
        font-family: Averia;
        color: white;

        @media (min-width: $S) {
          width: 100px;
          font-size: 18px;
        }

        &.configOk{
          float: right;
          background-color: $orange;
          opacity: 0.9;

          &:not(.toobigorsmall):hover{
            transform: scale(1.02);
            opacity: 1;
          }

          &.toobigorsmall{
            opacity: 0.2;
            cursor: unset;
          }
        }

        &.configCancel{
          float: left;
          //background-color: $typogray;
          background-color: var(--color-button-bg-hover); // trying a bit darker than default light button bg, but still light enough to not slap my eye
          color: var(--color-text);
          opacity: 0.9;

          &:hover{
            transform: scale(1.02);
            opacity: 1;
          }
        }
      }
    }
  }
  
  .dragscroll {
      scroll-behavior: unset;
      cursor: grabbing;
  }
}

.dark .artconfig {
  .variants .placeholder{
    background: url(../assets/images/variant-placeholder-dark.png);
  }

  .result{
    background: linear-gradient(90deg, #3a3a3a -20%, var(--color-artconfig-bg) 30%, var(--color-artconfig-bg) 70%, #3a3a3a 120%);

    @media (min-width: $S) {
      background: linear-gradient(90deg, #3a3a3a -10%, var(--color-artconfig-bg) 30%, var(--color-artconfig-bg) 70%, #3a3a3a 110%);
    }

    @media (min-width: $M) {
        background: linear-gradient(90deg, #3a3a3a 0%, var(--color-artconfig-bg) 30%, var(--color-artconfig-bg) 70%, #3a3a3a 100%);
    }

    @media (min-width: $L) {
        background: linear-gradient(90deg, #3a3a3a 0%, var(--color-artconfig-bg) 40%, var(--color-artconfig-bg) 60%, #3a3a3a 100%);
    }

    .frame-undo-btn:not(:hover){
      .a{
        border-right-color: #898888;
      }
      .d{
        border-color: #898888;
      }
      .t{
        color: #898888;
      }
    }
  }

  &.configmode .result{
    background: var(--color-bg);
  }

  .map {
    background-color: #303030;

    .mapboxgl-ctrl{
      .mapboxgl-ctrl-logo{
        opacity: 0.5;
      }

      &.mapboxgl-ctrl-attrib{
        //background-color: #1f1f1fba;
        background-color: transparent;

        a{
          color: #888;
        }
      }
    }
    
    .mapboxgl-ctrl-compass{
      //background-color: var(--color-header);
      background-color: #1b1b1b;
      box-shadow: 0 0 5px 0 #00000078;
      border-radius: 4px;

      .mapboxgl-ctrl-icon{
        background-image: url(../assets/images/mapbox-compass-dark.svg);
        opacity: 1;
      }
    }

    .popup{ 
      .nav{
        span{
          color: #b5b5b5;
            text-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
        }

        &:hover {
          span {
            text-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
          }
        }

        &.empty .fade{          
          background-image: url(../assets/images/variant-placeholder-dark.png) !important;
          
          + span{
            opacity: 0.15;
          }  
        }        
      }

      .letter-preview{
        border: 3px solid #787878;
        box-shadow: 5px 5px 30px 5px rgba(0, 0, 0, 0.5);
      }
    }

    .marker{
      background-color: #252323;
      color: var(--color-links);
      //box-shadow: 0 0 5px 0 #00000078;

      &.selectedLetter{
        background-color: #171717;
      }

      span.selectedLetter:not(.framed){
        color: var(--color-text);
      }
    }
  }
}

@keyframes rotate16x {  
  100% {
    transform: rotate(5760deg);
  }
}
@keyframes fadeIn {  
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOut {   
  100% {
    opacity: 0;
  }
}
@keyframes fadeOutBorder {   
  100% {
    border: 0;
    opacity: 0;
  }
}
</style>
